import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Route, Routes } from "react-router-dom";

import { useUserData } from "./context/UserDataContext.js";
import Homepage from "./components/homepage/Homepage";
import NewsList from "./components/newsList/NewsList";
import NewsContent from "./components/newsContent/NewsContent";
import PersonsList from "./components/personsList/PersonsList";
import MediaList from "./components/mediaList/MediaList";
import AboutUs from "./components/aboutus/AboutUs";
import ContactUs from "./components/contactus/ContactUs";

// Routes

const Authenticated = () => {
  const { userData } = useUserData();

  return (
    <>
      {" "}
      <Routes>
        <Route path="/" element={<Navigate to="/homepage" />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/news-list">
          <Route index element={<NewsList />} />
          <Route path=":search" element={<NewsList />} />
          <Route path=":search/:tag" element={<NewsList />} />
        </Route>{" "}
        <Route path="/news-content/:id" element={<NewsContent />} />
        <Route path="/opinion-list" element={<PersonsList />} />
        <Route path="/media-list" element={<MediaList />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="*" element={<Navigate to="/homepage" replace />} />
      </Routes>
      {/* 1 */}
      {/* <Route path="/redirect" element={<Navigate to="/setting-ring"/>}/> */}
      {/* 2 */}
      {/* <Route path="/setting/*" element={<Ring />} />
          in the Ring Component use the nested route like below:
          <Routers>
            <Route path="/nested" element={<Nested />} />
          </Routers> */}
    </>
  );
};
export default Authenticated;
